import React from 'react';
import { Modal, Input, Form, Select, Table, Tabs, Button, Divider, Empty, Switch } from 'antd';
import dialog from '../../../common/utility/dialog';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { TabPane } = Tabs;
const { Option } = Select;
const InputGroup = Input.Group;

class FormModalSustento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }
    handleBuscar = () => {

        var empleado = this.props.form.getFieldValue("idResponsable");
        if (empleado == null || empleado == undefined) {
            dialog.warning("Seleccione Empleado.");
            return false;
        }

        this.props.onSearch(empleado.key)
    }

    handleOk = (e) => {
        e.preventDefault();

        if (this.props.formValues.selectedRowKeys.length == 0) {
            dialog.warning("Debe seleccionar al menos 1 solicitud.");
            return false;
        }

        var itemLista =  this.props.formValues.selectedRowKeys;

        const form = {
            id: 0,
            JsonId: itemLista.join(", "),
            idCaja:this.props.formValues.idCaja
        }

        this.props.onSave(form, this.props.form);
    }





    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('idCajaChicaSolicitud', { initialValue: this.props.formValues.idCajaChicaSolicitud });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Devolución de Efectivo" : "Modificar Devolución de Efectivo"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={(properties) => {
                    if (!properties.target.className.toString().match("ant-modal-wrap") || properties.type === "keydown")
                        this.handleCancel();
                }}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="700px"
            >
                <Form>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        disabled
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.establecimientos.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-6">
                            <Form.Item label={"Monto Disponible en Caja " + (this.props.formValues.moneda)}
                                hasFeedback
                                validateStatus={this.props.formValues.montoDisponible > 0 ? "success" : "error"}>
                                {getFieldDecorator(`montoDisponible`, {
                                    initialValue: parseFloat(this.props.formValues.montoDisponible).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }]
                                })(
                                    <Input
                                        placeholder="Monto Pen"
                                        autoComplete="off"
                                        readOnly
                                        id="success"
                                        onKeyPress={global.onKeyPressDecimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-12">
                            <Form.Item label="Empleado">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("idResponsable", {
                                            initialValue: this.props.formValues.idResponsable
                                                ? { key: this.props.formValues.idResponsable }
                                                : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                },
                                            ],
                                        })(

                                            <Select
                                                showSearch
                                                labelInValue
                                                placeholder={"Seleccione Empleado"}
                                                optionFilterProp="children"
                                            >
                                                {this.props.formValues.empleados.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.id} - {item.nombre}</Option>
                                                ))}

                                            </Select>

                                        )}
                                    </Form.Item>

                                </InputGroup>


                            </Form.Item>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        <Button
                                            icon="search"
                                            type="success"
                                            onClick={this.handleBuscar}
                                        >
                                            Buscar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Documentos" key="1">

                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaDevolucionDetalle}
                                        rowSelection={{
                                            onChange: this.props.onChangeRow,
                                            selectedRowKeys: this.props.formValues.selectedRowKeys,
                                            hideDefaultSelections: false
                                        }}
                                        rowKey={record => record.id}
                                        locale={{
                                            emptyText: <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description='No se han agregado productos'
                                            />
                                        }}
                                        columns={[
                                            {
                                                title: 'Nro Caja Chica',
                                                dataIndex: 'numeroCaja',
                                                key: 'numeroCaja',
                                                align: 'center',
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Nro Solicitud',
                                                dataIndex: 'numero',
                                                key: 'numero',
                                                ellipsis: true,
                                            },
                                            {
                                                title: 'Moneda',
                                                dataIndex: 'moneda',
                                                key: 'moneda',
                                                ellipsis: true
                                            },
                                            {
                                                title: 'Monto Pendiente a Devolver',
                                                dataIndex: 'montoPendiente',
                                                key: 'montoPendiente',
                                                align: 'center',
                                                width: 150,
                                                render: (value) => (
                                                    <span>{value.toFixed(2)}</span>
                                                )
                                            }
                                        ]}
                                    />
                                </TabPane>

                            </Tabs>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModalSustento)